// The signed-in account holder whose consent is on record: matched by the
// internal id Cognito carries for them, falling back to email. A holder
// invited by the primary holder, or one created before consent was
// captured, has acceptTerms false and must accept before using the app.
export function currentAccountUser(account, currentUser) {
  const users = account?.users || [];
  const internalId = currentUser?.internalId || currentUser?.id;
  const byId = internalId
    ? users.find((user) => user?.id === internalId)
    : null;
  if (byId) {
    return byId;
  }

  const email = currentUser?.email?.toLowerCase();
  if (!email) {
    return null;
  }
  return users.find((user) => user?.email?.toLowerCase() === email) || null;
}

export function needsConsent(account, currentUser) {
  const user = currentAccountUser(account, currentUser);
  return Boolean(user) && user.acceptTerms !== true;
}

export default needsConsent;
